import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values  = {
    activeClass:   { type: String, default: "border-(--accent) text-(--accent)" },
    inactiveClass: { type: String, default: "border-transparent text-(--muted)" }
  }

  connect() {
    if (this.tabTargets.length > 0) {
      this._activate(this.tabTargets[0])
    }
  }

  show(event) {
    this._activate(event.currentTarget)
  }

  _activate(activeTab) {
    const panelId = activeTab.dataset.tabsPanelValue

    this.tabTargets.forEach(tab => {
      const isActive = tab === activeTab
      this.activeClassValue.split(" ").forEach(c => tab.classList.toggle(c, isActive))
      this.inactiveClassValue.split(" ").forEach(c => tab.classList.toggle(c, !isActive))
    })

    this.panelTargets.forEach(panel => {
      panel.hidden = panel.dataset.tabsPanelIdValue !== panelId
    })
  }
}
